/** Default page size for report grids and export history tables. */
export const DEFAULT_REPORT_PAGE_SIZE = 15;

/** Page size dropdown options for report grids and export history (ascending). */
export const REPORT_PAGE_SIZE_OPTIONS = [5, 10, 15, 25, 100];

/** Resolves UI page size from user/cache preference; never falls back to API `limit`. */
export function resolveReportPageSize(pageSize?: number | null): number {
  if (
    pageSize != null &&
    pageSize > 0 &&
    REPORT_PAGE_SIZE_OPTIONS.includes(pageSize)
  ) {
    return pageSize;
  }

  return DEFAULT_REPORT_PAGE_SIZE;
}
